//plantdata 接口封装

import {Header} from './http'
import {get, post} from './pdAxios'


// const searchUrl = '/find'
// const searchUrl = Header.pdBase + '/find'
export const botUrl = Header.pdBase + '/bot/pc.html?sysNum='
export const baseUrl = Header.pdBase + '/kgapi'
export const skdUrl = baseUrl

export const querySuggest = (data) => post(baseUrl + '/search/query/suggest', data)
export const simplekw = (data) => post(baseUrl + '/search/simplekw', data)
export const othersHotWords = (data) => post(baseUrl + '/search/hotList', data)
export const searchSchema = (data) => get(baseUrl + '/search/searchSchema', data)
export const importantCountry = (entityType, entityName) => post(baseUrl + `/search/relatedCountry/${entityType}/${entityName}`, {})
export const importantOrganization = (entityType, entityName) => post(baseUrl + `/search/relatedOrganizations/${entityType}/${entityName}`, {})
export const importantCity = (entityType, entityName) => post(baseUrl + `/search/relatedCity/${entityType}/${entityName}`, {})
export const importantIdustry = (entityType, entityName) => post(baseUrl + `/search/relatedIndustry/${entityType}/${entityName}`, {})
export const importantFirm = (entityType, entityName) => post(baseUrl + `/search/relatedCompany/${entityType}/${entityName}`, {})
export const importantPeople = (entityType, entityName) => post(baseUrl + `/search/relatedPeople/${entityType}/${entityName}`, {})

export const searchStatistics = () => post(baseUrl + `/ensearch/statistics`, {})//已处理
export const companyStatistics = (url) => get(`/api/analysis/brandMedia` + url, {})//已处理
export const countryStatistics = () => post(baseUrl + `/ensearch/pgdp`, {})//已处理
//export const searchBanner = () => post(baseUrl + `/search/banner`, {}) //没问题
//export const serviceLink = () => post(baseUrl + `/search/serviceLink `, {})//没问题
//export const pcConsult = () => post(baseUrl + `/api/pc/consult`, {})//没问题
//export const collectClear = () => post(baseUrl + `/api/pc/collectclear`, {})//没问题
//export const spaceCollect = () => post(baseUrl + `/api/pc/spacecollect`, {})
export const spaceList = (data) => post(`/api/pc/spacelist`, {...data})//没问题
